import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { setRoute } from "../../../../actions";
import UserFields from "../../../../components/UserFields";
import PaymentFields from "../../../../components/PaymentFields";
import ScopeOfServicesFields from "../../components/ScopeOfServicesFields";
import SummaryFields from "../../components/SummaryFields";
import Page from "../../../../components/Page";
import { translations } from "../../../../config";

const mapStateToProps = ( state ) =>
{
	return {
		route: state.route
	};
};

const mapDispatchToProps = ( dispatch ) =>
{
	return {
		resetRoute: () =>
		{
			dispatch( setRoute( null ) );
		}
	};
};

/**
 * Komponente um statische Inhalte auszugeben
 */
class Registration extends React.Component
{
	constructor( props )
	{
		super( props );
		
		this.nextStep = this.nextStep.bind( this );
		this.previousStep = this.previousStep.bind( this );
		this.saveValues = this.saveValues.bind( this );
		
		let step = sessionStorage.getItem( "RegistrationStep" ) !== null ? parseInt( sessionStorage.getItem( "RegistrationStep" ), 10 ) : 1;
		
		// Beim Neuladen der Seite sollen die Eingaben nicht verloren gehen
		this.state = {
			step: step,
			fieldValues: sessionStorage.getItem( "RegistrationFieldValues" ) !== null ? JSON.parse( sessionStorage.getItem( "RegistrationFieldValues" ) ) : {},
			processBar: {
				1: step > 1 ? "visited" : ( step === 1 ? "active" : "" ),
				2: step > 2 ? "visited" : ( step === 2 ? "active" : "" ),
				3: step > 3 ? "visited" : ( step === 3 ? "active" : "" ),
				4: step > 4 ? "visited" : ( step === 4 ? "active" : "" )
			}
		};
		
	} // function constructor(...)
	
	componentWillUnmount()
	{
		// Beim Unmount werden die gespeicherten Daten für die Registrierung gelöscht
		sessionStorage.removeItem( "RegistrationStep" );
		sessionStorage.removeItem( "RegistrationFieldValues" );
		
	} // function componentWillUnmount()
	
	saveValues( a_field_value, a_group )
	{
		// Der Session-Storage wird erst nach dem aktualisieren des States gesetzt
		this.setState(
			{
				fieldValues: Object.assign(
					{},
					this.state.fieldValues,
					{
						[ a_group ]: a_field_value
					}
				)
			},
			() =>
			{
				sessionStorage.setItem( "RegistrationFieldValues", JSON.stringify( this.state.fieldValues ) );
			}
		);
	} // function saveValues(...)
	
	nextStep()
	{
		let nextStep = this.state.step + 1;
		
		this.setState( {
				step: nextStep,
				processBar: {
					1: parseInt( nextStep, 10 ) > 1 ? "visited" : ( nextStep === 1 ? "active" : "" ),
					2: parseInt( nextStep, 10 ) > 2 ? "visited" : ( nextStep === 2 ? "active" : "" ),
					3: parseInt( nextStep, 10 ) > 3 ? "visited" : ( nextStep === 3 ? "active" : "" ),
					4: parseInt( nextStep, 10 ) > 4 ? "visited" : ( nextStep === 4 ? "active" : "" )
				}
			},
			() =>
			{
				sessionStorage.setItem( "RegistrationStep", nextStep );
			} );
		
	} // function nextStep()
	
	previousStep( a_step )
	{
		if ( a_step >= this.state.step )
		{
			return;
		}
		
		let previousStep = a_step ? a_step : this.state.step - 1;
		
		this.setState( {
			step: previousStep,
			processBar: {
				1: previousStep > 1 ? "visited" : ( previousStep === 1 ? "active" : "" ),
				2: previousStep > 2 ? "visited" : ( previousStep === 2 ? "active" : "" ),
				3: previousStep > 3 ? "visited" : ( previousStep === 3 ? "active" : "" ),
				4: previousStep > 4 ? "visited" : ( previousStep === 4 ? "active" : "" )
			}
		} );
		sessionStorage.setItem( "RegistrationStep", previousStep );
		
	} // function previousStep()
	
	switchFields( a_step )
	{
		switch ( a_step )
		{
			case 1:
				return <UserFields fieldValues={this.state.fieldValues}
				                   nextStep={this.nextStep}
				                   previousStep={this.previousStep}
				                   saveValues={this.saveValues}
				/>;
			case 2:
				return <ScopeOfServicesFields fieldValues={this.state.fieldValues}
				                              nextStep={this.nextStep}
				                              previousStep={this.previousStep}
				                              saveValues={this.saveValues}
				/>;
			case 3:
				return <PaymentFields fieldValues={this.state.fieldValues}
				                      nextStep={this.nextStep}
				                      previousStep={this.previousStep}
				                      saveValues={this.saveValues}
				/>;
			case 4:
				return <SummaryFields fieldValues={this.state.fieldValues}
				                      nextStep={this.nextStep}
				                      previousStep={this.previousStep}
				                      saveValues={this.saveValues}
				                      registrateUser={this.props.registrateUser}
				/>;
			default:
				this.props.resetRoute();
				break;
		}
		
	} // function switchFields(...)
	
	render()
	{
		return <Page title={translations.de_DE.words.registration} pageUrl={translations.de_DE.routes.registration}>
			<div className="col s12 light-grey boxShadowRight">
				<div className="checkout-wrap">
					<ul className="checkout-bar">
						<li className={`linked ${this.state.processBar[ 1 ]}`} onClick={() => this.previousStep( 1 )}>Persönliche Daten</li>
						<li className={`linked ${this.state.processBar[ 2 ]}`} onClick={() => this.previousStep( 2 )}>Warenkorb</li>
						<li className={`linked ${this.state.processBar[ 3 ]}`} onClick={() => this.previousStep( 3 )}>Zahlung</li>
						<li className={`linked ${this.state.processBar[ 4 ]}`} onClick={() => this.previousStep( 4 )}>Zusammenfassung</li>
					</ul>
				</div>
			</div>
			<div className={"cleared"}/>
			<div className={"col s12 unset-padding"}>
				{this.switchFields( this.state.step )}
			</div>
		</Page>;
		
	} // function render()
	
} // class

Registration = connect(
	mapStateToProps,
	mapDispatchToProps
)( Registration );

export default withRouter( Registration );
